import builder from '../builder';
import EmailActionUnread from '../../streamline-icons/light/email-action-unread.svg';

export default builder('IconEmailActionUnreadLight', EmailActionUnread);
